import type { ScreenWakeLockAdapter, ScreenWakeLockHandle } from "./types.js";

export interface NativeKeepAwakePlugin {
  setKeepAwake(options: { enabled: boolean }): Promise<void>;
}

export interface NativeScreenWakeLockAdapterOptions {
  readonly plugin: NativeKeepAwakePlugin;
  readonly supported?: boolean;
}

export function createNativeScreenWakeLockAdapter(
  options: NativeScreenWakeLockAdapterOptions,
): ScreenWakeLockAdapter {
  return {
    name: "native-screen-wake-lock",
    isSupported: () => options.supported ?? true,
    async request(): Promise<ScreenWakeLockHandle> {
      await options.plugin.setKeepAwake({ enabled: true });
      return {
        release: () => options.plugin.setKeepAwake({ enabled: false }),
      };
    },
  };
}
